/* Action types */
export const actionTypes = {
    GET_MY_PROFILE_SUCCESS: 'ACCOUNT/GET_MY_PROFILE_SUCCESS',
    GET_MY_LISTINGS_SUCCESS: 'ACCOUNT/GET_MY_LISTINGS_SUCCESS',
    GET_MY_POINTS_SUCCESS: 'ACCOUNT/GET_MY_POINTS_SUCCESS',
    LOGOUT_USER: 'ACCOUNT/LOGOUT_USER',
};
